


























































































import { Vue, Component, PropSync, Prop } from "vue-property-decorator";
import ServiceJob from "@/dataModels/serviceJobs/serviceJob";
import StaticLookupStore from "@/store/modules/staticLookupStore";
import { getModule } from "vuex-module-decorators";
import { ServiceJobResolutionNextServiceDue } from "@/dataModels/enums/serviceJobResolutionNextServiceDue";
import { ServiceJobType } from "@/dataModels/enums/serviceJobType";
import ServiceJobResolution from "@/dataModels/serviceJobs/serviceJobResolution";

@Component({
    name: "ServiceJobResolutions",
    components: {}
})
export default class ServiceJobResolutions extends Vue {
    @Prop() tab!: number;
    @PropSync("value") entity!: ServiceJob;

    public readonly staticLookupStore: StaticLookupStore = getModule(StaticLookupStore, this.$store);

    constructor() {
        super();
    }

    created(): void {
        if (!this.entity.resolutionDetails) {
            this.entity.resolutionDetails = new ServiceJobResolution();
        }
    }

    get serviceJobType(): typeof ServiceJobType {
        return ServiceJobType;
    }

    get serviceJobResolutionNextServiceDue() {
        return Object.entries(ServiceJobResolutionNextServiceDue).map(([key, value]) => ({
            value: key,
            name: value
        }));
    }

    get tabScope(): string {
        return `tab${this.tab}`;
    }
}
